import { render, staticRenderFns } from "./Extra.vue?vue&type=template&id=a9762502&scoped=true"
import script from "./Extra.vue?vue&type=script&lang=js"
export * from "./Extra.vue?vue&type=script&lang=js"
import style0 from "./Extra.vue?vue&type=style&index=0&id=a9762502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9762502",
  null
  
)

export default component.exports